import { render } from "./TemaFunksjonOgBruk.vue?vue&type=template&id=42d9f459&scoped=true"
import script from "./TemaFunksjonOgBruk.vue?vue&type=script&lang=js"
export * from "./TemaFunksjonOgBruk.vue?vue&type=script&lang=js"

import "./TemaFunksjonOgBruk.vue?vue&type=style&index=0&id=42d9f459&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d9f459"]])

export default __exports__